module.exports = __webpack_public_path__ + "img/bg-showcase-2.37b5a1e7.jpg";